<template>
    <el-select style="width:400px;" :multiple="multiple" v-model="val" @change="handleChange"
        :placeholder="placeholder">
        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
    </el-select>
</template>

<script>
import { page } from "@/api/questionnaire";
export default {
    props: {
        value: {
            type: Array | String | Number,
            default: "",
        },
        multiple: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: "请选择问卷"
        }
    },
    data() {
        return {
            val: "",
            options: [],
        };
    },
    watch: {
        value: {
            handler(val) {
                this.val = val;
            },
            immediate: true,
        },
    },
    mounted() {
        this.search();
    },
    methods: {
        search() {
            page({ page: 1, size: 999999 }).then(({ code, data, message }) => {
                if (code == 200) {
                    this.options = data.records || [];
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleChange(val) {
            this.$emit("input", val);
            this.$emit("change", val);
        },
    },
};
</script>

<style></style>
